

import { useState } from "react";
import { Link } from "react-router-dom"
import { desktopMenuList } from "./Data/navbar"

export default function Navbar({ onSelect }) {


    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);


    const toggleDropdown = (index) => {
        setOpenDropdownIndex(openDropdownIndex === index ? null : index);

    };
    const categoryImg =
    {
        logo: "/images/logo/logo1.png",
        img1: "/images/banner-1.jpg",
        img2: "/images/mens-banner.jpg",
        img3: "/images/womens-banner.jpg",
        img4: "/images/electronics-banner-2.jpg",

    }
    return (
        <>
            <header style={{ position: 'sticky', top: 0, zIndex: 1000, backgroundColor: 'white' }}>
                <div className=" bg-white topnav" >
                    <a href="#" className="navbar-brand  p-0 d-flex">

                        <img className="logo " src={categoryImg.logo} width="280" style={{marginLeft:"20px"}} alt="Logo" />
                    </a>
                    <nav className="desktop-navigation-menu navbar-light" style={{ flex: 1, alignItems: 'center' }}>


                        <div className="container">
                            <ul className="desktop-menu-category-list">

                                {desktopMenuList.map((item, idx) => (
                                    <li
                                        key={idx}
                                        className={`menu-category ${item.children || item.panel ? "has-dropdown" : ""} ${openDropdownIndex === idx ? "open" : ""}`}
                                    >
                                       <Link 
  href={"#"}
  className="menu-title"
  onClick={(e) => {
    if (item.children || item.panel) {
      e.preventDefault();
      toggleDropdown(idx);
    } 
    // ADD THIS CONDITION:
    else if (item.name === "Blog") {
      e.preventDefault();
      window.open("https://blog.cybersoftdev.com", "_blank", "noopener,noreferrer");
    } 
     else if (item.name === "IT Training Institute") {
      e.preventDefault();
      window.open("https://course.cybersoftdev.com", "_blank", "noopener,noreferrer");
    } 
    else {
      onSelect(item.name); 
    }
  }}
>
  {item.name}
</Link>

                                        {item.panel && (
                                            <div className="dropdown-panel">
                                                {item.panel.map((panelList, pIdx) => (
                                                    <ul key={pIdx} className="dropdown-panel-list" style={{ listStyle: "none", padding: "0px" }}>
                                                        {panelList.map((pItem, i) => (
                                                            <li key={i} className={pItem.type} style={{ margin: "0px" }}>
                                                                {pItem.iconClass && <i className={`${pItem.iconClass}`} style={{ marginRight: '8px', color: pItem.color }}></i>}
                                                                {pItem.name && <a href="#">{pItem.name}</a>}

                                                            </li>
                                                        ))}
                                                    </ul>
                                                ))}
                                            </div>
                                        )}


                                        {item.children && (
                                            <ul className="dropdown-list" style={{ width: "230px", padding: "20px" }}>
                                                {item.children.map((child, i) => (
                                                    <li className="dropdown-item" key={i}>
                                                        {child.iconClass && <i className={`${child.iconClass}`} style={{ marginRight: '8px', color: child.color }}></i>}
                                                        <a href={child.href}>{child.name}</a>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </li>
                                ))}
                                <li style={{ listStyle: "none" }}>
                                    <Link href={"#"} className="btn btn-csd"
                                        onClick={(e) => {

                                            onSelect("project"); // call the callback function

                                        }}
                                    >
                                        Projects
                                    </Link>
                                </li>
                            </ul>
                        </div>

                    </nav>
                </div>
                {isOpen && (
                    <nav className={`mobile-navigation-menu has-scrollbar ${isOpen ? 'open' : ''}`} data-mobile-menu>
                        <button className="menu-close-btn" style={{ float: "right" }} data-mobile-menu-close-btn onClick={closeMenu}>
                            {/* <ion-icon name="close-outline"></ion-icon> */}
                            ✖
                        </button>
                        <div className="menu-top">
                            <img src={categoryImg.logo} alt="Logo" width={230} height={80} />
                        </div>
                        <ul className="mobile-menu-list">
                            {desktopMenuList.map((label, idx) => (
                                <li
                                    className={`menu ${label.children ? "has-dropdown" : ""} ${openDropdownIndex === idx ? "open" : ""
                                        }`}
                                    key={idx}
                                >
                                    <a
                                        href={label.children ? "#" : label.href}
                                        className="menu-title"
                                        style={{ padding: "30px" }}
                                        onClick={(e) => {
                                            if (label.children) {
                                                e.preventDefault(); // stop navigation
                                                toggleDropdown(idx); // toggle dropdown
                                            } else {
                                                onSelect(label.name);
                                                closeMenu(); // close menu if not a dropdown
                                            }
                                        }}
                                    >
                                        {label.name}
                                    </a>


                                    {label.children && (
                                        <ul className="dropdown">
                                            {label.children.map((child, cidx) => (
                                                <li key={cidx}>

                                                    <a
                                                        href={child.href}
                                                        className="menu-title"
                                                        style={{ padding: "15px 40px" }}
                                                        onClick={closeMenu}
                                                    >
                                                        {child.name}
                                                    </a>
                                                </li>
                                            ))}

                                        </ul>
                                    )}

                                </li>

                            ))}

                        </ul>

                    </nav >
                )
                }


                <div className="mobile-bottom-navigation">
                    {[
                        { name: 'Menu', icon: 'fa-solid fa-bars', action: toggleMenu },
                        { name: 'Schedule', icon: 'fa-regular fa-calendar-days' },
                        { name: 'Home', icon: 'fa-solid fa-house home-icon text-white' },
                        { name: 'project', icon: 'fa-solid fa fa fa-desktop' },
                        { name: 'Blog', icon: 'fa-solid fa-passport' },
                    ].map((item, idx) => (
                        <button
                            key={idx}
                            className="menu-btn"
                            onClick={() => {
                                if (item.action) {
                                    item.action(); // run special handler if available
                                } else {
                                    onSelect(item.name); // send the name to parent
                                }
                            }}
                        >
                            <i className={item.icon}></i>
                        </button>
                    ))}
                </div>




            </header >
        </>
    )
}